import axios from 'axios';
var languageType = '';
var language = sessionStorage.getItem('language');
if(language != 'null'&& language != null){
	languageType = language;
};
var http = axios.create({
  baseURL: 'http://ad.dinovor.com/',
  // baseURL: 'http://127.0.0.1:8080/',
  // baseURL: 'http://8.210.126.231:8081/',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
		'language': languageType
  },
  transformRequest: [function (data) {
    var newData = '';
    for (var k in data) {
      if (data.hasOwnProperty(k) === true) {
        newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
      }
    }
    return newData;
  }]
});

function apiAxios(method, url, params,response) {
  http({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
  }).then(function (res) {
    response(res);
  }).catch(function (err) {
    response(err);
  })
}

function apiAxios2(method, url, params, async, response) {
  http({
    method: method,
    url: url,
		async: async==''?true:async,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
  }).then(function (res) {
    response(res);
  }).catch(function (err) {
    response(err);
  })
}

export default {
  get: function (url, params, response) {
    return apiAxios('GET', url, params, response)
  },
  post: function (url, params, response) {
    return apiAxios('POST', url, params, response)
  },
	post2: function (url, params, async, response) {
		return apiAxios2('POST', url, params, async, response)
	},
  put: function (url, params, response) {
    return apiAxios('PUT', url, params, response)
  },
  delete: function (url, params, response) {
    return apiAxios('DELETE', url, params, response)
  }
}



// WEBPACK FOOTER //
// ./src/base/js/api.js